import PaginationItems from 'paginationItems';
import Thumbnail from './components/thumbnail'
import Paginator from './searchPageComponents/paginator';
import SortComponent from './searchPageComponents/sortComponents';
import SRCache from './searchPageComponents/searchResultCache';
import testData from './searchPageComponents/testData';
import {getURL, formatData, createUrl, createAjaxUrl, urlParser} from './searchPageComponents/utils';

const NO_SERVER_DATA = false;


/**
 * Объект-состояние страницы поиска. Используется для создания ajax-урла и урла для страницы
 * @type {{page: number, sort_by: string, query: string}}
 */
const state = {
  limit: 60,
  page: 1,
  sort_by: 'relevance',
  query: ''
};
Object.assign( state, urlParser( window.location.pathname ) );


const historyPush = savedState => {
  history.pushState(savedState, null, createUrl(savedState));

  $('.videos .thum1 a').each(function () {
    var params = ['source=' + source];
    if (subid) {
      params.push('subid=' + subid)
    }
    if (pageState.tag) {
      params.push('ad_tags=' + pageState.tag)
    }
    if (typeof $(this).attr('id') !== 'undefined') {
      if ($(this).attr('id').substr(0, 4) === 'asdf')
        $(this).attr('href', $(this).attr('href') + '?' + params.join('&'));
    }
  });

  $('.videos > li').each(function(index) {
    var thumbnail = new Thumbnail(this);
    thumbnail.init();
  });
};


const _srCache = new SRCache();

/**
 * Типы сортировок
 * @type {*[]}
 */
const sortTypes = [
  {name: 'Relevance', type: 'relevance'},
  {name: 'Popular', type: 'popular'},
  {name: 'Latest', type: 'latest'},
  {name: 'Longest', type: 'longest'}
];
for(let key in sortTypes)
  if( sortTypes[ key ].type === state.sort_by ) sortTypes[ key ].active = true;



/**
 * Скрипт начинает работу только по загрузке дом-дерева
 */
document.addEventListener('DOMContentLoaded', () => {
  let template = document.querySelector('#search-results_template');
  if(!template) return false;

  template = template.innerHTML;
  let pgnPlace = document.querySelector('.pgn-place');
  let filterPlace = document.querySelector('.sort-place');
  let searchInput = document.querySelector('input[type=search]#q');


  if(NO_SERVER_DATA) searchInput.value = 'brunette blonde';
  state.query = searchInput.value;


  /**
   * Экземпляр компонента сортировки
   * @type {SortComponent}
   */
  const sorting = new SortComponent({
    sortTypes,
    clickCallback: sortType => updateStateAndGetRequest({sort_by: sortType, page: 1}, historyPush)
  });
  filterPlace.insertBefore(sorting.template, filterPlace.firstChild);


  /**
   * Экземпляр компонента пагинатора
   * @type {Paginator}
   */
  const paginator = new Paginator({
    visibleCount: state.limit,
    clickCallback: page => updateStateAndGetRequest({page}, historyPush)
  });
  pgnPlace.insertBefore(paginator.template, pgnPlace.firstChild);


  /**
   * Отображаемые элементы
   */
  const paginationItems = new PaginationItems({
    renderTo: 'i-search-results',
    visibleCount: state.limit,
    lsKey: 'searchResults',
    template: template
  });


  /**
   * Рендер компонентами актуальных данных и состояния
   * @param data
   * @param state
   * @param callback
   */
  const setData = (data, state, callback) => {
    paginator.init( data.total, state.page );
    sorting.init( state.sort_by );
    paginationItems.renderData( data );
    paginator.disable = false;
    sorting.disable = false;

    if(callback) callback( state );
  };



  /**
   *
   * @param newState
   * @param callback
   */
  const updateStateAndGetRequest = (newState, callback) => {
    paginator.disable = true;
    sorting.disable = true;

    window.scrollTo(0,0);

    for(let key in newState)
      state[key] = newState[key];

    /**
     * Проверяем наличие кэшированные данных
     */
    let cachedData = _srCache.getDataByState( state );

    /**
     * Если есть данные к кэше - рендерим их, если нет - делаем запрос и добавляем в sessionStorage
     */

    if(NO_SERVER_DATA){
      setData( testData, state, callback );
    } else {
      cachedData ? setData( cachedData, state, callback ) : getURL(
        createAjaxUrl( state ),
        data => {
          data = JSON.parse(data);

          data.data = formatData( data.data, state );
          _srCache.saveDataByState( state, data );
          setData( data, state, callback );
        }
      );
    }
  };

  updateStateAndGetRequest( Object.assign(state, {query: searchInput.value}), historyPush );

  /**
   * Обновление страницы при действиях юзера history.back() / history.forward()
   */
  window.addEventListener('popstate', PopStateEvent => updateStateAndGetRequest( PopStateEvent.state ));
});




// WEBPACK FOOTER //
// ./src/desktop/scripts/searchPage.js